export default __webpack_public_path__ + "static/media/payout.24db234e.svg";